import React, { FC } from 'react';
import { Props } from './types';

const MyPharmacyIcon: FC<Props> = (props: Props) => {
  return (
    <svg
      viewBox={`0 0 24 24`}
      width="24"
      height="24"
      fill={props.fill}
      {...props}
    >
      <path d="M9.22287 16.2457L8.72762 18.2345H11.2575C11.2575 18.2345 10.2747 17.3998 9.22287 16.2457Z" />
      <path d="M12.741 18.2345H15.2709L14.7756 16.2457C13.7239 17.3998 12.741 18.2345 12.741 18.2345Z" />
      <path d="M15.806 15.0435L16.6008 18.2355H20.7047L18.8498 14.562H16.1808C16.0839 14.6902 15.8317 15.0113 15.806 15.0435Z" />
      <path d="M7.0769 19.5271H2.64318L1 22.7709H6.26916L7.0769 19.5271Z" />
      <path d="M16.9231 19.5271L17.7308 22.7709H23L21.3568 19.5271H16.9231Z" />
      <path d="M15.5929 19.5271H8.40553L7.59776 22.7709H16.4007L15.5929 19.5271Z" />
      <path d="M7.39702 18.2355L8.19187 15.0436C8.16609 15.0114 7.91397 14.6902 7.81705 14.562H5.14801L3.29314 18.2355L7.39702 18.2355Z" />
      <path d="M12.1634 2C10.6068 2 9.11405 2.61833 8.01341 3.71897C6.91278 4.8196 6.29445 6.31239 6.29445 7.86892C6.29445 12.62 12.1634 17.0915 12.1634 17.0915C12.1634 17.0915 18.0323 12.62 18.0323 7.86892C18.0323 6.31239 17.414 4.8196 16.3133 3.71897C15.2127 2.61833 13.7199 2 12.1634 2ZM14.782 8.29651L14.346 8.73249L12.1634 10.9208L9.54192 8.29931C9.25802 8.00828 9.10023 7.6171 9.10275 7.21054C9.10527 6.80398 9.26789 6.41479 9.55538 6.1273C9.84287 5.83981 10.2321 5.67719 10.6386 5.67467C11.0452 5.67215 11.4364 5.82993 11.7274 6.11383L12.1634 6.54981L12.6021 6.11383C12.7444 5.96612 12.9147 5.84827 13.1031 5.76717C13.2915 5.68606 13.4942 5.64334 13.6993 5.64149C13.9043 5.63964 14.1077 5.6787 14.2976 5.75639C14.4874 5.83408 14.6598 5.94885 14.8047 6.09397C14.9496 6.23908 15.0642 6.41164 15.1416 6.60156C15.2191 6.79147 15.2579 6.99492 15.2558 7.2C15.2537 7.40509 15.2107 7.6077 15.1293 7.79597C15.048 7.98425 14.9299 8.15441 14.782 8.29651Z" />
    </svg>
  );
};
export default MyPharmacyIcon;
